//
// Este archivo es el punto de entrada principal de la aplicación React.
// Se encarga de renderizar el componente raíz (`App`) en el DOM,
// utilizando `hydrateRoot` para la hidratación del contenido pre-renderizado
// o `createRoot` para un renderizado inicial en el cliente.
//
import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async'; // Mantenelo para el SEO
import './index.css'; // Mantenelo para el diseño inicial
import App from './App';

const container = document.getElementById('root');
const rootElement = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (container && container.hasChildNodes()) {
  hydrateRoot(container, rootElement);
} else {
  createRoot(container).render(rootElement);
}